<template>
  <mdb-modal  :show="show" @close="$emit('close')">
    <mdb-modal-header>
      <mdb-modal-title>강사 선택</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body style="font-size:15px">
      <div class="mb-3">
        <span class="bolder">검색: </span>
        <input class="input-underline" v-model="keyword"/>
        <mdb-btn color="" class="p-0 m-0 ml-1" @click.native="keyword=''" icon="times"/>
      </div>
      <div v-if="keyword">
        <div v-for="(t, i) in filteredTeacher" :key="i" class="pointer" @click="onSelectTeacher(t)">
          <label><input type="radio" name="teacher"> {{t.name}}</label>
        </div>
      </div>
      <div v-else>강사 이름으로 검색하세요(글자 입력후 엔터)</div>
      <div class="text-center mt-4">
        <mdb-btn color="primary" class="p-2 px-4" @click.native="onOk">선택</mdb-btn>
        <mdb-btn color="secondary" class="p-2 px-4" @click.native="$emit('close')">취소</mdb-btn>
      </div>
    </mdb-modal-body>
  </mdb-modal>
</template>
<script>
import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import NcsTraining from '@/models/NcsTraining'
export default {
  name: 'TeacherSelectDlg',
  components: { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody },
  props: ['org', 'show', 'value'],
  data: () => ({
    TAG: 'TeacherSelectDlg',
    keyword: '',
    teachers: [],
    teacher: {}
  }),
  computed: {
    filteredTeacher () {
      if (!this.keyword) return []
      return this.teachers
        .filter(t => !this.keyword || t.name.indexOf(this.keyword) !== -1)
    }
  },
  methods: {
    async load () {
    },
    onOk () {
      const { _id, name } = this.teacher
      this.$emit('input', { _id, name })
      this.$emit('close')
    },
    onSelectTeacher (t) {
      this.teacher = t
    }
  },
  async created () {
    this.teachers = await this.$member.teacherList()
  },
  watch: {
  }
}
</script>
